import { h } from 'preact';

import AutoPushNotifications from '../../auto-push-notifications/auto-push-notifications';
import { initInPage } from '../../auto-push-notifications/helpers/init-in-page';
import { renderInPage } from '../../auto-push-notifications/renderers/render-in-page';

export const renderWPN = ({ data, pageState, pageActions, WPNCtx, elementId, type }) => (
  <AutoPushNotifications
    htmlProps={data}
    state={WPNCtx.state}
    actions={WPNCtx.actions}
    pageActions={pageActions}
    render={renderInPage}
    initCallback={initInPage}
    elementIdInPage={elementId}
    blockInPageType={type}
    isActiveInPage={pageState.activeBlock === type}
  />
);
